import React from 'react';
import styles from './topContainerV2.module.scss';
export default function TopContainerV2({ children, hiddenTab = false, globalFilter , className="" , subClassName=""}) {
  let styleObj = {}

  return (
    <div className={`${styles.topContainerV2Wrapper} ${className}`}>
      <div className={`${styles.topContainerV2} ${hiddenTab ? styles.hiddenTab : ''} ${subClassName}`}>
        {children}
      </div>
      {globalFilter && globalFilter}
    </div>
  );
}
